import React from 'react';
import Slider from '../components/Slider';

const HeroBanner = () => {
    return (
        <section id='home'>
            <Slider />
        </section>
    );
};

export default HeroBanner;